/** Read an image blob URL's natural dimensions. Resolves zeros on failure.
 *  DOM-bound; covered by E2E, not Vitest. */
export function probeImageSize(
  blobUrl: string,
): Promise<{ width: number; height: number }> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = () => resolve({ width: 0, height: 0 });
    img.src = blobUrl;
  });
}
